import React from "react";

import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import NumberValue from "../../components/NumberValue";



const TabWallet: React.FC = () => {
  const stats = useSelector((state: RootState) => state.stats);
  const purchaseValue = parseFloat((stats.in_app_products?.inAppPpurchasesValue || 0).toString()).toFixed(2);

  return (
    <Stack direction="column" spacing={4}>
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Ad Rewards</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Total</TableCell>
              <TableCell align="right"><NumberValue number={stats.ad_rewards?.total}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Failed</TableCell>
              <TableCell align="right"><NumberValue number={stats.ad_rewards?.failed}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>In App Products</TableCell>
              <TableCell align="right">Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">IAP Value</TableCell>
              <TableCell align="right"><NumberValue number={parseFloat(purchaseValue)} prefix="$"/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">IAP Count</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.inAppPpurchasesCount}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Gifts Sent</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.giftsSent}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Premium Messages</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.premiumMessagesSent}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Total Travel Modes</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.totalTravelModes}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Active Travel Modes</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.activeTravelModes}/></TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">Total Stealth Modes</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.totalStealthModes}/></TableCell>
            </TableRow>
            <TableRow >
              <TableCell component="th" scope="row">Active Stealth Modes</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.activeStealthModes}/></TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">Total Visitors and Likers modes</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.totalVisitorsAndLikersMode}/></TableCell>
            </TableRow>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Active Visitors and Likers modes</TableCell>
              <TableCell align="right"><NumberValue number={stats.in_app_products?.activeVisitorsAndLikersMode}/></TableCell>
            </TableRow>
            
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Wallet</TableCell>
              <TableCell align="right">Value</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">Deposit Coins</TableCell>
              <TableCell align="right"><NumberValue number={stats.wallet?.depositCoins}/></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">Deposit Transactions</TableCell>
              <TableCell align="right"><NumberValue number={stats.wallet?.depositCount}/></TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">Withdrawal Coins</TableCell>
              <TableCell align="right"><NumberValue number={stats.wallet?.withdrawalCoins}/></TableCell>
            </TableRow>
            
            <TableRow>
              <TableCell component="th" scope="row">Withdrawal Transactions</TableCell>
              <TableCell align="right"><NumberValue number={stats.wallet?.withdrawalCount}/></TableCell>
            </TableRow>

            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">Total Available Coins</TableCell>
              <TableCell align="right"><NumberValue number={stats.wallet?.activeCoins}/></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

    </Stack>
  );
};

export default TabWallet;